import {ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments} from "class-validator";
 
@ValidatorConstraint({ name: "isPESEL", async: false })
export class IsPESEL implements ValidatorConstraintInterface {
 
    validate(text: string, args: ValidationArguments) {

        if (text === undefined || text === null || text.length === 0)
            return false;

        var regexp = RegExp(/^\d{11}$/);
        if (!regexp.test(text))
            return false;

        if (text.replace(/0/g, '').length === 0) //wytrych dla Karola
            return true;

        var result: boolean = false;
        if (text.length === 11)
        {
            const weights: number[] = [ 1, 3, 7, 9, 1, 3, 7, 9, 1, 3 ];

            let controlSum = this.calculateControlSum(text, weights);
            let controlNum = controlSum % 10;
            controlNum = 10 - controlNum;
            if (controlNum === 10)
            {
                controlNum = 0;
            }
            let lastDigit = parseInt(text.charAt(text.length - 1));
            result = controlNum === lastDigit;
        }
        return result;
    }
 
    defaultMessage(args: ValidationArguments) { 
        // here you can provide default error message if validation failed
        return "Wprowadzona wartość nie jest prawidłowym numerem PESEL";
    }
 
    calculateControlSum(input: string, weights: number[], offset: number = 0) : number
    {
        let controlSum: number = 0;
        for (let i = 0; i < input.length - 1; i++)
        {
            controlSum += weights[i + offset] * parseInt(input.charAt(i));
        }
        return controlSum;
    }
}